export const SET_GLOBAL_ERROR = 'SET_GLOBAL_ERROR';
export const RESET_GLOBAL_ERROR = 'RESET_GLOBAL_ERROR';
